module.exports = __webpack_public_path__ + "static/media/head-shop.087488b4.png";